import type { DataSource } from "~/data-sources/types/data-source";

function getIsDataSourceOnboarded(
  workspaceId: number,
  dataSources: DataSource[],
) {
  if (!dataSources.length) {
    return false;
  }

  const isStorageOnboarded =
    localStorage.getItem(`hasOnboardedDataSources`) === `${workspaceId}`;

  const disconnectedSources = dataSources.filter(
    (source) => !source.isConnected,
  );

  const connectedSourcesCount = Math.max(
    dataSources.length - disconnectedSources.length,
    0,
  );

  if (!isStorageOnboarded) {
    localStorage.removeItem(`hasOnboardedDataSources`);
  }

  return (
    (disconnectedSources.length > 0 && !isStorageOnboarded) ||
    connectedSourcesCount === 0
  );
}

function setIsDataSourceOnboarded(workspaceId: number) {
  localStorage.setItem(`hasOnboardedDataSources`, `${workspaceId}`);
}

export { getIsDataSourceOnboarded, setIsDataSourceOnboarded };
